import React, { useState, useEffect, ChangeEvent, useCallback, FormEvent } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import SiteWrapper from "../../base/SiteWrapper";
import Product from '../../interfaces/Product';

import {
  Page,
  Button,
  Form,
  Card,
  Icon
} from "tabler-react";
import { ApiFidegg } from "../../services/apiFideggAdmin";
import { Alerta } from "../../utils/Alerta";
import Params from "../../interfaces/Params";

function ProductsForm() {

  const history = useHistory();

  const { id } = useParams<Params>();

  const initialValues: Product = {
    id: "",
    description: "",
    product_platform_id: "",
    value: 0,
  };

  const [product, setProduct] = useState<Product>(initialValues);

  useEffect(() => {
    (async () => {
      if(!!id) {
        const response = await ApiFidegg.get(`products/${id}`);
        if (response.status === 200) {
          setProduct(response.data);
        }
      }
    })();
  }, [id]);

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setProduct({...product, [name]: value});
  }

  function handleClickCancel(event: FormEvent) {
    event.preventDefault();
    history.goBack();
  }

  const handleSubmit = useCallback(
    async (event: FormEvent) => {
      try {
        event.preventDefault();

        const data = {
          description: product.description,
          product_platform_id: product.product_platform_id,
          value: product.value,
        }

        if(!!product.id) {
          await ApiFidegg.put(`products/${product.id}`, data)
          Alerta('Configuração de produto atualizada!', 'success');
        } else {
          await ApiFidegg.post('products', data)
          Alerta('Configuração de produto incluída!', 'success');
        }

        history.push('/products');
      } catch (err) {
        if(!!product.id) {
          Alerta('Erro ao atualizar a configuração!');
        } else {
          Alerta('Erro ao cadastrar a configuração!');
        }
      }
    }, [history, product]
  );

  return (
    <SiteWrapper>
      <Form onSubmit={handleSubmit}>
        <Page.Card
          title="Produto"
          footer={
            <Card.Footer>
              <div className="d-flex">
                <Button link onClick={handleClickCancel} >Cancelar</Button>
                <Button type="submit" color="primary" className="ml-auto">
                  Salvar
                </Button>
              </div>
            </Card.Footer>
          }
        >
          <Form.FieldSet>
            <Form.Group label="Descrição">
              <Form.Input
                name="description"
                value={product.description || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>
                ID do produto na plataforma
                <Icon name="help-circle" style={{marginLeft:'5px'}} title="ID do produto na sua plataforma de e-commerce" />
              </Form.Label>
              <Form.Input
                name="product_platform_id"
                value={product.product_platform_id || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Valor
              </Form.Label>
              <Form.Input
                name="value"
                value={product.value || ""}
                onChange={handleChange}
                type="number"
              />
            </Form.Group>
          </Form.FieldSet>
        </Page.Card>
      </Form>
    </SiteWrapper>
  );
}

export default ProductsForm;